import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { ArrowGlyph } from 'education-icons';
import { Text, SimpleText } from 'platform-components/common';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import ClassNameEditorControl from 'common.components/class-name-editor/class-name-editor';
import { CLASSNAME_EDITOR_VIEW, CLASSNAME_EDITOR_MODE } from 'common.components/class-name-editor/types';
import { getCurrentClass, getCurrentTeamPrevLevel } from 'common.components/user/selectors';
import { classPropTypes, loadingStatusPropType } from 'utils/data-prop-types';
import { getTrimmedName } from 'utils/get-trimmed-name';
import { getTeamIdFromPath } from 'utils/path';

import { NewYearModalClassCaption } from '../__class-caption/new-year-modal__class-caption';
import { NewYearModalControl } from '../__control/new-year-modal__control';
import { NEW_YEAR_MODAL_CONTROL_VIEW } from '../__control/types';
import { NewYearModalControls } from '../__controls/new-year-modal__controls';
import { NewYearModalDescription } from '../__description/new-year-modal__description';
import { NewYearModalHeader } from '../__header/new-year-modal__header';
import { NewYearModalMainContent } from '../__main-content/new-year-modal__main-content';
import * as actions from '../actions';
import { MAX_CLASS_NAME_LENGTH } from '../new-year-modal.constants';
import { getLoadingStatus, getNewLevel, getNewName } from '../selectors';

import './new-year-modal__content_rename.scss';

export class NewYearModalContentRename extends React.Component {
    static propTypes = {
        team: classPropTypes.isRequired,
        loadingStatus: loadingStatusPropType,
        newName: PropTypes.string,
        newLevel: PropTypes.number,
        onRename: PropTypes.func.isRequired,
        onArchive: PropTypes.func.isRequired,
        prevLevel: PropTypes.number,
        setNewLevel: PropTypes.func.isRequired,
        setNewName: PropTypes.func.isRequired,
        setPage: PropTypes.func.isRequired,
        clearState: PropTypes.func.isRequired,
    };

    componentDidMount() {
        const {
            team: { level },
            newLevel,
            setNewLevel,
        } = this.props;

        if (!newLevel) {
            const defaultNewLevel = level;
            setNewLevel(defaultNewLevel);
        }
    }

    componentWillUnmount() {
        const { clearState } = this.props;

        clearState();
    }

    render() {
        const {
            team: { name: className },
            newName,
            newLevel,
            setNewName,
            setNewLevel,
            loadingStatus,
            prevLevel,
            onRename,
            onArchive,
        } = this.props;

        const isLoading = loadingStatus === LOADING_STATUSES.LOADING;

        return (
            <>
                <NewYearModalHeader id="newYearModal.rename2.header" />
                <NewYearModalMainContent>
                    <NewYearModalDescription id="newYearModal.rename2.description" />
                    <div className="new-year-modal__class-controls">
                        <div className="new-year-modal__class-control">
                            <NewYearModalClassCaption id="newYearModal.rename2.lastYear" />
                            <div className="new-year-modal__class-data">
                                <Text
                                    id="newYearModal.rename2.lastYearClass"
                                    type={Text.TYPE.MARKDOWN}
                                    values={{
                                        className: getTrimmedName(className, MAX_CLASS_NAME_LENGTH),
                                        level: prevLevel,
                                    }}
                                />
                            </div>
                        </div>
                        <ArrowGlyph className="new-year-modal__arrow" />
                        <div className="new-year-modal__class-control">
                            <NewYearModalClassCaption id="newYearModal.rename2.newYear" />
                            <ClassNameEditorControl
                                letter={newName}
                                mix="new-year-modal__class-name-controls"
                                mode={CLASSNAME_EDITOR_MODE.EDIT}
                                nameSettingStatus={loadingStatus}
                                number={newLevel}
                                onLetterChange={setNewName}
                                onNumberChange={setNewLevel}
                                view={CLASSNAME_EDITOR_VIEW.PLAIN}
                            />
                        </div>
                    </div>
                </NewYearModalMainContent>
                <NewYearModalControls stackable>
                    <NewYearModalControl
                        disabled={isLoading}
                        onClick={onArchive}
                        view={NEW_YEAR_MODAL_CONTROL_VIEW.DECLINE}
                    >
                        <SimpleText id="newYearModal.form.notWorkingAnymore" />
                    </NewYearModalControl>
                    <NewYearModalControl
                        onClick={onRename}
                        progress={isLoading}
                        view={NEW_YEAR_MODAL_CONTROL_VIEW.ACCEPT}
                    >
                        <SimpleText id="newYearModal.form.rename2.accept" />
                    </NewYearModalControl>
                </NewYearModalControls>
            </>
        );
    }
}

const mapStateToProps = (storeState) => {
    const classId = getTeamIdFromPath();

    return {
        team: getCurrentClass(storeState, { classId }),
        loadingStatus: getLoadingStatus(storeState),
        newName: getNewName(storeState, { classId }),
        newLevel: getNewLevel(storeState),
        prevLevel: getCurrentTeamPrevLevel(storeState, { classId }),
    };
};

const mapDispatchToProps = (dispatch) => {
    const { setPage, setNewLevel, setNewName, clearState } = actions;

    return bindActionCreators(
        {
            setPage,
            setNewLevel,
            setNewName,
            clearState,
        },
        dispatch
    );
};

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(NewYearModalContentRename);
